<template>
    <div>
        <b-row>
            <b-col cols="12">
                <div class="solution-steps">
                    <b-tabs pills content-class="mt-4" align="center">
                        <b-tab title="Calculate" @click="emitEvent('reset-shows-props')">
                        </b-tab>
                        <b-tab title="MHLV" :active="showMhlvSelection" @click="emitEvent('show-mhlv-selection')">
                            <MhlvSelection />
                        </b-tab>
                        <b-tab title="Summary" :active="showMhlvSummary" @click="emitEvent('show-mhlv-summary')">
                            <MhlvSummary />
                        </b-tab>
                    </b-tabs>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import MhlvSelection from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/MhlvSolution/MhlvSelection'
import MhlvSummary from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/MhlvSolution/MhlvSummary'

export default {
    props: {
        showMhlvSelection: Boolean,
        showMhlvSummary: Boolean,
    },
    components: {
        MhlvSelection,
        MhlvSummary,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    methods: {
        emitEvent(eventName) {
            solutionEventBus.$emit(eventName)
        },
    },
}
</script>